import { render, staticRenderFns } from "./PureRadioSlide.vue?vue&type=template&id=49478623&scoped=true&"
import script from "./PureRadioSlide.vue?vue&type=script&lang=ts&"
export * from "./PureRadioSlide.vue?vue&type=script&lang=ts&"
import style0 from "./PureRadioSlide.vue?vue&type=style&index=0&id=49478623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49478623",
  null
  
)

export default component.exports